import appRoutes from "./app.routes";
import authRoutes from "./auth.routes";
import userRoutes from "./user.routes";
import seedRoutes from "./seed.routes";
import customerRoutes from "./customer.routes";
import mailboxRoutes from "./mailbox.routes";
import accountRoutes from "./account.routes";

/**
 * All the routes of the application
 * @description import all the routes in this file
 * and spread them into an array of all the routes of the application
 */
const routes = [
  ...appRoutes,
  ...authRoutes,
  ...userRoutes,
  ...seedRoutes,
  ...customerRoutes,
  ...mailboxRoutes,
  ...accountRoutes,
];

export default Object.freeze(routes);
